module.exports = __webpack_public_path__ + "img/thomas_burger.7096e057.jpg";